<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [title]="'Machine Details'" [class]="'kt-portlet__head--lg'">

	</kt-portlet-header>
	<div class="kt-portlet__body">
		<form #form="ngForm" [formGroup]="editInfoForm" (ngSubmit)="onSubmited()" class="col-xl-10 col-md-12 col-sm-12 mt-3 mx-auto">

			<mat-label><b>ID Info</b></mat-label>
			<br>
			<br>

			<div class="row">
				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput placeholder="Machine ID" maxlength="30" readonly formControlName="machine_id" required>
					<mat-error *ngIf="editInfoForm.get('machine_id').hasError('required')">
						Please enter a valid Machine ID
					</mat-error>
				</mat-form-field>

				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput placeholder="Machine Name" maxlength="100" formControlName="machine_name" required>
					<mat-error *ngIf="editInfoForm.get('machine_name').hasError('required')">
						Please enter a valid Machine Name
					  </mat-error>
				</mat-form-field>

				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput placeholder="Serial No" maxlength="30" readonly formControlName="serial_no" required>
					<mat-error *ngIf="editInfoForm.get('machine_id').hasError('required')">
						Please enter a valid Serial No
					</mat-error>
				</mat-form-field>

				<!-- <mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput placeholder="Machine Name" maxlength="100" formControlName="machine_name" >
				</mat-form-field> -->

			</div>
			<div *ngIf="role !== 'campusadmin'">
				<mat-label><b>Group Info</b></mat-label>
				<br>
				<br>

				<div class="row">
					<mat-form-field *ngIf="role == 'sadmin'" class="col-xl col-md-5 col-sm-12">
						<mat-label>Select Partner</mat-label>
						<input matInput type="text" (click)="openDialog('disti')" class="pointer" formControlName="disti_id"/>
						<mat-icon (click)="openDialog('disti')" matSuffix>arrow_drop_down</mat-icon>
						<mat-error *ngIf="editInfoForm.get('disti_id').hasError('required')">
							Please select a valid Partner
						</mat-error>
					</mat-form-field>

					<mat-form-field *ngIf="role == 'sadmin' || role == 'distiadmin'" class="col-xl col-md-5 col-sm-12">
						<mat-label>Select Market</mat-label>
						<input matInput type="text" (click)="openDialog('market')" class="pointer" formControlName="market_id"/>
						<mat-icon (click)="openDialog('market')" matSuffix>arrow_drop_down</mat-icon>
					</mat-form-field>

					<mat-form-field *ngIf="(role == 'sadmin' || role == 'distiadmin' || role == 'marketadmin')" class="col-xl col-md-5 col-sm-12">
						<mat-label>Select Client</mat-label>
						<input  matInput type="text" (click)="openDialog('client')" class="pointer" formControlName="client_id"/>
						<mat-icon (click)="openDialog('client')" matSuffix>arrow_drop_down</mat-icon>
						<mat-error *ngIf="editInfoForm.get('client_id').hasError('required')">
							Please enter a valid Client
						  </mat-error>
					</mat-form-field>

					<mat-form-field *ngIf="role == 'sadmin' || role == 'distiadmin' ||  role == 'clientadmin' || role == 'marketadmin'" class="col-xl col-md-5 col-sm-12">
						<mat-label>Select Campus</mat-label>
						<input matInput type="text" (click)="openDialog('campus')" class="pointer" formControlName="campus_id"/>
						<mat-icon (click)="openDialog('campus')" matSuffix>arrow_drop_down</mat-icon>
						<mat-error *ngIf="editInfoForm.get('campus_id').hasError('required')">
							Please enter a valid Campus
						</mat-error>
					</mat-form-field>

					<!-- <mat-form-field class="col-xl col-md-5 col-sm-12">
						<input matInput placeholder="Machine Name" maxlength="100" formControlName="machine_name" >
					</mat-form-field> -->

				</div>
			</div>

			<br>
				<mat-label><b>Location Info</b></mat-label>
			<br>

			<div class="row">
				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput formControlName="address_line1" maxlength="100"  placeholder="Address Line 1" required>
					<mat-error *ngIf="editInfoForm.get('address_line1').hasError('required')">
						Please enter a valid Address
					</mat-error>
				</mat-form-field>

				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput formControlName="address_line2" maxlength="100"  placeholder="Address Line 2">
				</mat-form-field>

				<div class="col-xl">

				</div>
			</div>

			<div class="row">
				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput formControlName="city" maxlength="50"  placeholder="City" required>
					<mat-error *ngIf="editInfoForm.get('city').hasError('required')">
						Please enter a valid City
					</mat-error>
				</mat-form-field>

				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput formControlName="state" maxlength="30" placeholder="State"  required>
					<mat-error *ngIf="editInfoForm.get('state').hasError('required')">
						Please enter a valid State
					</mat-error>
				</mat-form-field>

				<mat-form-field class="col-xl col-md-5 col-sm-12">
					<input matInput formControlName="zip_code" maxlength="15" placeholder="Zip"  required>
					<mat-error *ngIf="editInfoForm.get('zip_code').hasError('required')">
						Please enter a valid zip code
					</mat-error>
				</mat-form-field>
			</div>



			<div class="row">
				<mat-form-field class="col-xl-4 col-md-5 col-sm-12">
					<mat-select placeholder="Time Zone" formControlName="time_zone" [disabled]="(roleIndex > 0)?true:false" required>
						<mat-option *ngFor="let tz of timeZoneObj" [value]="tz.value">{{tz.label}}</mat-option >
					</mat-select>
					<mat-error *ngIf="editInfoForm.get('time_zone').hasError('required')">
						Please choose a valid Time Zone
					</mat-error>
				</mat-form-field>

				<mat-form-field class="col-xl-4 col-md-5 col-sm-12">
					<mat-select placeholder="Machine Status" formControlName="mac_status" required>
						<mat-option *ngFor="let stat of macStats" [value]="stat.value">{{stat.label}}</mat-option >
						<!-- <mat-option value="2">Production</mat-option >
						<mat-option value="1">Warehouse</mat-option > -->
					</mat-select>
					<mat-error *ngIf="editInfoForm.get('mac_status').hasError('required')">
						Please choose a valid Machine Status
					</mat-error>
				</mat-form-field>
			</div>

			<br>

			<div class="text-right mt-3" *ngIf="!((roleIndex > 0)?true:false)">
				<button mat-raised-button type="button" (click)="onBack()" class="mat-danger">Back</button> &nbsp;
				<button mat-raised-button [disabled]="!editInfoForm.valid" type="submit" color="primary">Update Info</button>
			</div>

		</form>
	</div>
</div>
